import { saveMediaRecommendationPreferencesToCookie } from './media-recommendation-preferences-cookie-operations';
import { selectMediaOptions } from './media-recommendation-preferences-selectors';
import {
    resetMediaSourcesToDefaults,
    setDamMediaEnabled,
    setMediaGuidance,
    setMinimumStockSuitabilityScore,
    setMusicRecommendationMode,
    setStockMediaEnabled,
    setWorkspaceFolderIds,
    setWorkspaceMediaMode,
} from './media-recommendation-preferences-slice';

import type { MusicRecommendationModeEnum, WorkspaceMediaModeEnum } from 'js/src/client';
import type { AppDispatch, RootState } from 'js/src/libs/RootState';

export const updateStockMediaEnabledOperation = (enabled: boolean) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setStockMediaEnabled(enabled));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateDamMediaEnabledOperation = (enabled: boolean) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setDamMediaEnabled(enabled));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateWorkspaceMediaModeOperation = (mode: WorkspaceMediaModeEnum) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setWorkspaceMediaMode(mode));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateWorkspaceFolderIdsOperation = (folderIds: number[]) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setWorkspaceFolderIds(folderIds));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateMediaGuidanceOperation = (guidance: string) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setMediaGuidance(guidance));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateMinimumStockSuitabilityScoreOperation = (score: number | null) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setMinimumStockSuitabilityScore(score));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const updateMusicRecommendationModeOperation = (mode: MusicRecommendationModeEnum) => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(setMusicRecommendationMode(mode));
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};

export const resetMediaSourcesToDefaultsOperation = () => {
    return (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(resetMediaSourcesToDefaults());
        const mediaOptions = selectMediaOptions(getState());
        saveMediaRecommendationPreferencesToCookie(mediaOptions);
    };
};
